
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 60 60"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('linearGradient',{attrs:{"x1":"50%","y1":"2.231%","x2":"50%","y2":"99.716%","id":"a"}},[_c('stop',{attrs:{"stop-color":"#FFC330","offset":"0%"}}),_c('stop',{attrs:{"stop-color":"#EF942A","offset":"100%"}})])]),_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('circle',{attrs:{"fill":"url(#a)","cx":"30","cy":"30","r":"30"}}),_c('path',{attrs:{"d":"M29.856 42.303c-.376 0-.755 0-1.147-.04a16.322 16.322 0 01-8.173-2.917.606.606 0 11.674-1.006 15.106 15.106 0 007.563 2.703 15.324 15.324 0 009.733-2.703.606.606 0 01.94.606.598.598 0 01-.254.388 16.6 16.6 0 01-9.336 2.97zM18.895 28.495a.606.606 0 01-.533-.88 3.794 3.794 0 016.69-.001.607.607 0 11-1.07.573 2.582 2.582 0 00-4.553 0 .61.61 0 01-.534.308zm22.483 0a.61.61 0 01-.533-.32 2.582 2.582 0 00-4.553 0 .606.606 0 11-1.067-.573 3.79 3.79 0 016.686 0c.15.291.041.65-.246.808a.618.618 0 01-.287.085z","fill":"#FFF","fill-rule":"nonzero"}})])])
          )
        }
      }
    